import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useCallback } from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import normalizeCSSModules from '../../utils/css-modules';
import styles from './button.module.css';
import { useGroup } from '../group/utils';
import { handleKeyPressEnter } from '../../utils/handle-keypress-enter';
var s = normalizeCSSModules(styles);
var getIconName = function getIconName(success, error, warning) {
  if (success) {
    return 'check-circle';
  }
  if (error) {
    return 'exclamation-circle';
  }
  if (warning) {
    return 'exclamation-triangle';
  }
  return;
};
var SimpleButton = function SimpleButton(_ref) {
  var _classNames;
  var children = _ref.children,
    opened = _ref.opened,
    controlRef = _ref.controlRef,
    infoRef = _ref.infoRef,
    native = _ref.native,
    info = _ref.info,
    nativeSelectRef = _ref.nativeSelectRef,
    nativeHandleChange = _ref.nativeHandleChange,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? true : _ref$block,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'primary' : _ref$background,
    dataTest = _ref.dataTest,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$empty = _ref.empty,
    empty = _ref$empty === void 0 ? false : _ref$empty,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    onToggle = _ref.onToggle,
    onBlur = _ref.onBlur,
    _ref$readonly = _ref.readonly,
    readonly = _ref$readonly === void 0 ? false : _ref$readonly,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$size = _ref.size,
    externalSize = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$success = _ref.success,
    success = _ref$success === void 0 ? false : _ref$success,
    _ref$warning = _ref.warning,
    warning = _ref$warning === void 0 ? false : _ref$warning,
    _ref$valid = _ref.valid,
    valid = _ref$valid === void 0 ? false : _ref$valid,
    name = _ref.name,
    hint = _ref.hint,
    spaced = _ref.spaced,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  var group = useGroup();
  var size = group.present && group.size || externalSize;
  success = success || valid;
  var iconName = getIconName(success, error, warning);
  var handleToggle = useCallback(function (event) {
    if (disabled) {
      return;
    }
    if (onToggle) {
      onToggle(!opened, event);
    }
  }, [opened, onToggle, disabled]);
  return React.createElement("div", {
    className: classNames(s.wrapper, block && s.block, spaced && s.spaced, group.present && !group.first && s.group),
    style: Object.assign(Object.assign({}, group.present && {
      flex: group.width
    }), group.present && {
      maxWidth: group.maxWidth
    })
  }, React.createElement("button", {
    className: classNames(s.button, s[size], s[background], block && s.block, success && s.success, warning && s.warning, error && s.error, selected && s.selected, label && size !== 'l' && s.labeled, readonly && s.readonly, (!group.present || group.present && group.first) && s.roundedLeft, (!group.present || group.present && group.last) && s.roundedRight),
    "data-test": dataTest,
    disabled: disabled || readonly,
    ref: controlRef,
    onClick: handleToggle,
    onKeyPress: handleKeyPressEnter(handleToggle),
    type: "button",
    name: name,
    onBlur: onBlur
  }, size === 'l' && React.createElement("div", {
    className: classNames(s.content, (!label || !children) && s.single)
  }, label && React.createElement("div", {
    className: classNames(s.label, (_classNames = {}, _defineProperty(_classNames, s.floating, children), _defineProperty(_classNames, s.placeholder, !children && empty), _classNames))
  }, label, required && React.createElement("div", {
    className: s.star
  }, "*")), children && React.createElement("div", {
    className: classNames(s.value, empty && s.placeholder)
  }, children)), size !== 'l' && React.createElement(React.Fragment, null, label && React.createElement("div", {
    className: s.label
  }, label, " ", required && React.createElement("div", {
    className: classNames(s.star, s.sticky)
  }, "*")), React.createElement("div", {
    className: classNames(s.content, s.value, empty && s.placeholder)
  }, children)), iconName && React.createElement("span", {
    className: classNames(s.icon, s.status)
  }, React.createElement(Icon, {
    name: iconName
  })), (info === null || info === void 0 ? void 0 : info.show) && React.createElement("span", {
    className: classNames(s.icon, s.info),
    ref: infoRef
  }, React.createElement(Icon, {
    name: "information-circle"
  })), React.createElement("span", {
    className: classNames(s.icon, s.arrow, opened && s.opened)
  }, React.createElement(Icon, {
    size: "s",
    name: "chevron-down"
  })), native && React.createElement("select", {
    ref: nativeSelectRef,
    className: s.native,
    onChange: nativeHandleChange,
    disabled: disabled || readonly
  })), hint && React.createElement("span", {
    className: classNames(s.hint, error && s.error, warning && s.warning),
    "data-test": error ? 'error' : 'hint'
  }, hint));
};
export default SimpleButton;